import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/proxy/searchAccommodation', request, cancelToken)
}

export {get}
